<div class="container-fluid">

  <h4 id="upper">Traitement des Recommandation</h4>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <!-- <div class="col-auto">
            <a href="javascript:void(0);" class="btn btn-success mb-2" id="gras" (click)="openModal()">
              <i class="mdi mdi-plus me-2"></i> Ajouter une recommandation
            </a>
          </div> -->
          <div class="row mb-md-2">
            <div class="col-sm-12 col-md-6">
              <!-- <div class="dataTables_length" id="tickets-table_length"><label
                  class="d-inline-flex align-items-center">Afficher
                  <select name="tickets-table_length" aria-controls="tickets-table" name="pageSize"
                    class="custom-select custom-select-sm form-control form-control-sm mx-2">
                    <option [ngValue]="10">10</option>
                    <option [ngValue]="25">25</option>
                    <option [ngValue]="50">50</option>
                    <option [ngValue]="100">100</option>
                  </select> Lignes</label></div> -->
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_filter" class="dataTables_filter text-md-end"><label
                  class="d-inline-flex align-items-center">Rechercher:
                  <input [(ngModel)]="searchTerm" type="text" name="searchTerm"
                    class="form-control form-control-sm ms-2" aria-controls="tickets-table" placeholder="Libellé"
                    (keyup)="applyFilter($event.target.value)" (input)="applyFilter($event.target.value)"></label></div>
            </div>
            <!-- End search -->
          </div>
          <div class="table-responsive mt-3">
            <table class="table table-bordered">
              <thead class="thead-light rwd-table">
                <tr>
                  <th>Libellé</th>
                  <th>Date Suivi</th>
                  <th>Date MO</th>
                  <th>Niveau d'exécution (%)</th>
                  <th>Difficultés</th>
                  <th>Solutions</th>
                  <th>Reste à faire</th>
                  <th>Observations</th>
                  <th>Recommandation</th>
                  <th style="width: 120px;">Actions</th>


                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of paginatedItems">
                  <td>{{ item.libelle }}</td>
                  <td>{{ item.date_suivi | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ item.date_mo | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ item.niveau_execution }}%</td>
                  <td>{{ item.difficultes }}</td>
                  <td>{{ item.solutions }}</td>
                  <td>{{ item.reste_a_faire }}</td>
                  <td>{{ item.observations }}</td>
                  <td>{{ item.recommandation?.libelle }}</td>
                  <td>
                    <a (click)="confirmSuppression(item)" href="javascript:void(0);" class="text-danger"
                      v-b-tooltip.hover title="Delete">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>

                </tr>
              </tbody>
            </table>


          </div>
        </div>

        <div *ngIf="paginatedItems.length === 0 && isLoading === false" class="d-flex justify-content-center">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Aucune donnée trouvée</h5>
              </div>
            </div>
          </div>

        </div>
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
          [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
      </div>

    </div>
  </div>
</div>

<ng-template #recoommandationModal let-modal>
  <!-- Contacts model  -->
  <div class="modal-header">
    <h5 class="modal-title">Ajouter une suivie de recommandation</h5>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form>
        <div class="row">
          <!-- Libellé -->
          <div class="mb-3 col-md-6">
            <label for="libelle" class="form-label">Libellé</label>
            <input type="text" id="libelle" name="libelle" class="form-control" [(ngModel)]="item.libelle" required />
          </div>

          <!-- Date de suivi -->
          <div class="mb-3 col-md-6">
            <label for="date_suivi" class="form-label">Date de suivi</label>
            <input type="date" id="date_suivi" name="date_suivi" class="form-control" [(ngModel)]="item.date_suivi"
              required />
          </div>
        </div>

        <div class="row">
          <!-- Date de mise en œuvre -->
          <div class="mb-3 col-md-6">
            <label for="date_mo" class="form-label">Date de mise en œuvre</label>
            <input type="date" id="date_mo" name="date_mo" class="form-control" [(ngModel)]="item.date_mo" required />
          </div>

          <!-- Niveau d'exécution (%) -->
          <div class="mb-3 col-md-6">
            <label for="niveau_execution" class="form-label">Niveau d'exécution (%)</label>
            <input type="number" id="niveau_execution" name="niveau_execution" class="form-control"
              [(ngModel)]="item.niveau_execution" min="0" max="100" required />
          </div>
        </div>

        <div class="row">
          <!-- Difficultés -->
          <div class="mb-3 col-md-6">
            <label for="difficultes" class="form-label">Difficultés</label>
            <textarea id="difficultes" name="difficultes" class="form-control" [(ngModel)]="item.difficultes"
              rows="3"></textarea>
          </div>

          <!-- Solutions -->
          <div class="mb-3 col-md-6">
            <label for="solutions" class="form-label">Solutions</label>
            <textarea id="solutions" name="solutions" class="form-control" [(ngModel)]="item.solutions"
              rows="3"></textarea>
          </div>
        </div>

        <div class="row">
          <!-- Reste à faire -->
          <div class="mb-3 col-md-6">
            <label for="reste_a_faire" class="form-label">Reste à faire</label>
            <textarea id="reste_a_faire" name="reste_a_faire" class="form-control" [(ngModel)]="item.reste_a_faire"
              rows="3"></textarea>
          </div>

          <!-- Observations -->
          <div class="mb-3 col-md-6">
            <label for="observations" class="form-label">Observations</label>
            <textarea id="observations" name="observations" class="form-control" [(ngModel)]="item.observations"
              rows="3"></textarea>
          </div>
        </div>

        <!-- Boutons -->
        <div class="text-end">
          <button (click)="close()" type="button" class="btn btn-light ms-1">
            <i class="pi pi-times" style="color: #212529"></i> Annuler
          </button>&nbsp;

          <button type="submit" class="btn btn-success">
            <i class="pi pi-save" style="color: white"></i> Enregistrer
          </button>
        </div>
      </form>


    </div>
  </div>


</ng-template>
<ngx-ui-loader></ngx-ui-loader>

<p-confirmDialog />
<p-toast />